export const appParameters = {
  APP_CODE: 'VTT',
  APP_NAME: 'Bioflux Trading',
  REQUIRED_ROLES: [],
  REQUIRED_GROUPS: [],
  S3_PATH: 'your-s3-path', // usually is the name of the app divided by "-". example: trading-crude-tracking
};
